import { ExternalLink, PlayCircle } from "lucide-react";
import { btn } from "@/components/common/Ornament";

export function toEmbed(url) {
  if (!url) return null;
  try {
    const u = new URL(url);
    const h = u.hostname.replace("www.", "");
    if (h === "youtube.com" && u.searchParams.get("v")) return `https://www.youtube.com/embed/${u.searchParams.get("v")}`;
    if (h === "youtu.be") return `https://www.youtube.com/embed${u.pathname}`;
    if (h === "youtube.com" && u.pathname.startsWith("/embed/")) return url;
    if (h === "vimeo.com") return `https://player.vimeo.com/video${u.pathname}`;
    if (h.endsWith("matterport.com") || h.endsWith("kuula.co") || h === "player.vimeo.com") return url;
  } catch {
    return null;
  }
  return null;
}

function Embed({ url, label, testId }) {
  const embed = toEmbed(url);
  return (
    <div data-testid={testId}>
      <p className="eyebrow mb-3">{label}</p>
      {embed ? (
        <div className="aspect-video rounded-lg overflow-hidden border border-[#E2DCD2] bg-black">
          <iframe src={embed} title={label} className="w-full h-full" allow="autoplay; fullscreen; xr-spatial-tracking" allowFullScreen />
        </div>
      ) : (
        <a href={url} target="_blank" rel="noopener noreferrer" className={btn.primary}>
          <ExternalLink className="h-4 w-4" /> Open {label.toLowerCase()}
        </a>
      )}
    </div>
  );
}

export default function MediaEmbed({ videoUrl, tourUrl }) {
  if (!videoUrl && !tourUrl) {
    return (
      <div className="flex items-center gap-3 text-sm text-slate-500 border border-dashed border-[#E2DCD2] rounded-lg p-6" data-testid="media-empty">
        <PlayCircle className="h-5 w-5 text-[#C59B27]" /> A video or virtual tour link will appear here once added by the admin.
      </div>
    );
  }
  return (
    <div className="grid gap-8 lg:grid-cols-2">
      {videoUrl && <Embed url={videoUrl} label="Video" testId="media-video" />}
      {tourUrl && <Embed url={tourUrl} label="Virtual Tour" testId="media-tour" />}
    </div>
  );
}
